export default {
  namespaced: true,
  state: {
    curAdjustType: '',
  },
  mutations:{
    SET_CUR_ADJUST_TYPE:(state, type)=> {
      state.curAdjustType = type
    }
  },
  actions: {
  }
}
